/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsDoubleSeNw = createReactComponent("outline", "arrows-double-se-nw", "IconArrowsDoubleSeNw", [["path", { "d": "M3 10l11 11", "key": "svg-0" }], ["path", { "d": "M14 17v4h-4", "key": "svg-1" }], ["path", { "d": "M14 3h-4v4", "key": "svg-2" }], ["path", { "d": "M21 14l-11 -11", "key": "svg-3" }]]);

export { IconArrowsDoubleSeNw as default };
//# sourceMappingURL=IconArrowsDoubleSeNw.mjs.map
